import React, { useEffect, useState } from 'react';
import {
  Box, AlertTitle, Alert, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Grid, TextField, IconButton, Container, Checkbox,
  FormControlLabel
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useCarrito } from '../context/CarritoContext';
import Navbar from '../Navbar/Navbar';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import ModalAgregarDireccion from './AgregarDireccionModa';

const CarritoPedido = () => {
  const {
    carrito,
    totalCantidad,
    totalPrecio,
    limpiarCarrito,
    modificarCantidad,
    eliminarDelCarrito
  } = useCarrito();

  const codigosApiMichelin = ['00264', '00380', '00793', '00832', '00862', '00958', '01088', '01174', '01201', '01281', '01286', '01313', '01327', '01359', '01528', '01577', '01589', '01614', '01771', '01931', '01983', '02262', '02300', '02344', '02352', '02359', '02372', '02390', '02623', '02657', '02685', '02987', '03149', '03393', '03481', '03527', '03629', '03632', '03637', '03644', '03744', '03769', '03815', '04032', '04034', '04147', '04253', '04357', '04374', '04778', '04785', '04935', '04997', '05034', '05192', '05271', '05325', '05372', '05396', '05614', '05707', '05788', '05825', '05853', '05902', '06016', '06073', '06260', '06280', '06367', '06447', '06449', '06518', '06599', '06644', '06890', '06926', '06948', '07003', '07069', '07074', '07111', '07213', '07218', '07389', '07493', '07685', '07789', '07913', '07934', '08022', '08052', '08056', '08385', '08522', '08557', '08763', '08781', '08858', '09052', '09129', '09183', '09185', '09209', '09483', '09656', '09725', '09857', '09881', '09883', '10009', '10080', '10165', '10261', '10300', '10325', '10365', '10385', '10412', '10496', '10522', '10526', '10703', '10867', '10905', '11175', '11181', '11294', '11397', '11435', '11527', '11781', '11782', '11800', '12049', '12182', '12353', '12359', '12449', '12657', '12750', '12772', '12877', '12981', '13041', '13079', '13092', '13251', '13534', '13840', '13871', '13881', '14015', '14025', '14189', '14196', '14828', '14885', '15052', '15324', '15531', '15702', '15794', '15814', '15830', '15903', '16183', '16309', '16411', '16460', '16639', '16682', '16689', '16932', '17087', '17109', '17137', '17219', '17286', '17488', '17779', '18126', '18333', '18478', '18580', '18910', '19443', '19451', '19555', '19577', '19599', '19605', '19808', '20037', '20062', '20152', '20173', '20409', '20432', '20617', '20639', '20817', '20820', '20855', '21039', '21325', '21408', '21548', '21554', '21565', '21574', '21747', '21842', '22311', '22320', '22358', '23115', '23173', '23270', '23371', '23431', '23507', '23549', '23693', '23743', '24156', '24420', '24541', '24663', '24727', '24766', '24952', '25022', '25083', '25217', '25373', '25528', '25585', '25603', '25722', '25864', '26061', '26070', '26409', '26672', '26964', '27075', '27353', '27354', '27428', '27439', '27459', '27519', '28170', '28346', '28484', '28742', '28897', '29409', '29567', '29621', '29705', '29715', '29960', '29964', '30209', '30234', '30260', '30479', '30693', '30771', '30939', '31010', '31169', '31259', '31840', '31887', '31951', '31973', '32357', '32390', '32455', '32528', '32592', '32617', '33069', '33095', '33112', '33172', '33200', '33211', '33323', '33572', '33589', '33611', '33658', '33720', '33791', '33799', '33905', '33976', '33985', '34161', '34167', '34388', '34457', '34846', '34879', '34883', '34965', '35053', '35413', '35549', '35654', '35723', '35726', '35787', '35915', '36022', '36312', '36326', '36346', '36394', '36416', '36513', '36658', '36773', '36813', '37003', '37009', '37028', '37033', '37505', '37549', '37587', '37675', '37853', '37892', '37907', '38029', '38063', '38082', '38261', '38282', '38287', '38353', '38645', '38827', '38860', '39001', '39056', '39299', '39489', '39527', '39562', '39661', '39694', '39717', '39750', '39823', '40116', '40211', '40571', '40640', '40750', '40782', '41519', '41526', '41725', '42284', '42869', '42911', '43025', '43081', '43501', '43808', '43847', '43996', '44019', '44044', '44329', '44391', '44468', '44873', '44926', '44929', '44945', '45486', '45674', '45912', '46442', '47518', '47973', '48131', '48442', '48719', '49531', '49739', '50153', '50352', '50466', '50779', '50946', '51064', '51097', '51139', '51200', '51405', '51646', '51810', '52157', '52872', '52924', '53322', '53473', '53738', '53791', '54332', '54620', '55288', '56237', '56400', '56577', '56986', '57267', '57280', '57304', '57310', '57716', '58070', '58075', '58242', '58571', '59310', '59321', '59444', '59499', '59614', '59641', '59682', '59755', '59800', '59874', '60558', '61368', '61823', '62023', '62547', '62677', '62899', '63342', '63760', '63964', '64261', '64280', '64338', '64938', '65323', '65330', '65637', '65724', '65998', '66558', '66893', '66901', '66946', '67256', '67400', '67462', '67497', '67637', '68293', '68444', '68866', '69212', '69230', '69343', '69371', '69401', '69713', '69859', '70164', '70264', '70539', '70568', '70968', '71004', '71282', '71509', '71527', '71904', '71931', '71948', '72239', '72714', '72844', '72898', '72901', '73134', '73184', '73361', '73430', '73712', '74839', '74866', '74995', '75045', '75183', '75198', '75495', '75990', '76070', '76155', '76950', '77143', '77368', '77605', '78074', '78123', '78138', '78163', '78199', '78900', '79153', '79569', '79572', '79600', '79683', '79734', '79827', '79871', '80270', '80655', '80913', '81038', '81332', '81507', '81746', '82059', '82561', '82566', '82637', '82875', '83033', '83054', '83286', '83425', '84034', '84035', '84125', '84454', '84948', '85024', '85328', '85467', '85538', '85587', '85765', '85914', '86150', '86440', '86594', '86800', '86882', '87309', '87416', '87451', '87490', '87581', '87996', '88058', '88142', '88176', '88627', '89284', '89335', '90757', '90855', '91214', '91459', '91644', '91718', '91762', '91786', '91897', '91993', '92440', '92622', '92632', '93363', '93452', '93920', '94112', '94380', '94455', '94732', '95379', '95455', '95712', '96096', '96128', '96232', '96583', '97350', '97351', '97410', '98364', '98512', '98871', '98884'];
  const Nombre = localStorage.getItem('Nombre');
  const Seguimiento = localStorage.getItem('Seguimiento');
  const Asesor = localStorage.getItem('Asesor');
  const PedidoExpress = Cookies.get('PedidoExpress');
  const IdUsuario = Cookies.get('IdUsuario');
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [comentario, setComentario] = useState('');
  const [direcciones, setDirecciones] = useState([]);
  const [productoNegado, setProductoNegado] = useState('');
  const [direccionSeleccionada, setDireccionSeleccionada] = useState("");
  const [pedidoExpressActivo, setPedidoExpressActivo] = useState(false);
  const [permitirPedidoExpress, setPermitirPedidoExpress] = useState(false);
  const [openDireccionModal, setOpenDireccionModal] = useState(false);

  // 1. Estado para los nuevos datos de entrega (Michelin sin existencias)
  const [datosEntrega, setDatosEntrega] = useState({
    direccion: '',
    cp: '',
    nombreEntrega: '',
    telefono: '',
    correo: ''
  });

  const zona = Cookies.get('Facturacion');
  const tieneAdvantage = carrito.some(
    item => item.gama?.toUpperCase().includes('ADVANTAGE')
  );
  
  // Tu lógica existente que detecta si el código es Michelin y las existencias son iguales a 0
  const tieneMichelin = carrito.some(item =>
    codigosApiMichelin.includes(item.MSPN?.toUpperCase()) &&
    Number(item.existencias) === 0
  );

  const ZONAS_MAYOREO = {
    "MAYOREO AGUASCALIENTES": [
      "BODEGA CALVILLO",
      "BODEGA RINCON",
      "SUC GALERIAS",
      "SUC MATRIZ",
      "SUC NORTE",
      "SUC ORIENTE",
      "SUC PASEOS",
      "SUC SUR",
    ],
    "MAYOREO JALISCO": [
      "CEDIS GUADALAJARA",
      "SUC GDL LOPEZ MATEOS",
      "SUC GDL MARIANO OTERO",
      "SUC GUADALAJARA",
    ],
    "MAYOREO PUERTO VALLARTA": [
      "SUC PUERTO VALLARTA"
    ],
    "MAYOREO LEON": ["SUC LEON"],
    "MAYOREO COLIMA": [],
    "MAYOREO DURANGO": ["BODEGA DURANGO"],
    "MAYOREO ZACATECAS": ["SUC GUADALUPE", "SUC ZACATECAS"],
  };
  const ZonaUsuario = Cookies.get("Facturacion");

  const productos = carrito.map(item => ({
    MSPN: item.MSPN,
    cantidad: item.cantidad
  }));

  const obtenerDirecciones = async () => {
    const payload2 = {
      idUsuario: IdUsuario,
    };
    try {
      const response = await fetch(`https://bibliotecadlago.com/php/direcciones.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload2)
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMessage(data.message || 'Error al obtener direcciones');
        return;
      }
      setDirecciones(data.data)
    } catch (error) {
      console.error('Error de red:', error);
    }
  }

  const validarInventarioExpress = () => {
    const sucursalesZona = ZONAS_MAYOREO[ZonaUsuario] || [];

    return carrito.every((item) => {
      if (!item.inventario_detalle) return false;

      const inventarioZona = item.inventario_detalle.filter((inv) =>
        sucursalesZona.includes(inv.sucursal)
      );

      const totalDisponible = inventarioZona.reduce(
        (acc, inv) => acc + Number(inv.cantidad),
        0
      );

      return totalDisponible >= item.cantidad;
    });
  };

  useEffect(() => {
    obtenerDirecciones();
  }, [IdUsuario]);

  useEffect(() => {
    if (
      totalCantidad >= 1 &&
      totalCantidad <= 4 &&
      validarInventarioExpress()
    ) {
      setPermitirPedidoExpress(true);
    } else {
      setPermitirPedidoExpress(false);
      setPedidoExpressActivo(false);
    }
  }, [totalCantidad, carrito]);

  // Manejador del cambio en los inputs de entrega
  const handleDatosEntregaChange = (e) => {
    const { name, value } = e.target;
    setDatosEntrega(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (tieneMichelin) {
      if (!datosEntrega.direccion || !datosEntrega.cp || !datosEntrega.nombreEntrega || !datosEntrega.telefono || !datosEntrega.correo) {
        setErrorMessage('Por favor, completa todos los datos de entrega obligatorios para el pedido Michelin.');
        return;
      }
    }

    const payload = {
      IdUsuario,
      Usuario: localStorage.getItem('Nombre'),
      total: totalCantidad,
      productos,
      NombreCambio: Nombre,
      totalPrecio: totalPrecio,
      Comentario: comentario,
      ProducoNoEncontrado: productoNegado,
      Zona: zona,
      Tipo: tieneMichelin ? 'Michelin' : '',
      Direccion: tieneMichelin ? datosEntrega.direccion : null,
      Cp: tieneMichelin ? datosEntrega.cp : null,
      NombreEntrega: tieneMichelin ? datosEntrega.nombreEntrega : null,
      Telefono: tieneMichelin ? datosEntrega.telefono : null,
      Correo: tieneMichelin ? datosEntrega.correo : null,
    };

    const payloadPedidoExpress = {
      IdUsuario,
      total: totalCantidad,
      productos,
      NombreCambio: Nombre,
      totalPrecio: totalPrecio,
      Comentario: comentario,
      ProducoNoEncontrado: productoNegado,
      Direccion: direccionSeleccionada,
    };

    if (pedidoExpressActivo ){
      try {
        const response = await fetch(`https://bibliotecadlago.com/php/pedidoExpress.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payloadPedidoExpress)
        });

        const data = await response.json();

        if (!response.ok) {
          setErrorMessage(data.message || 'Error al guardar el pedido');
          return;
        }

        limpiarCarrito();
        navigate('/pedidos.html');

      } catch (error) {
        console.log(error);
        setErrorMessage('Error de conexión con el servidor');
      }
    } else {
      try {
        const response = await fetch(`https://bibliotecadlago.com/php/pedidov3.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (!response.ok) {
          setErrorMessage(data.message || 'Error al guardar el pedido');
          return;
        }

        limpiarCarrito();
        if (tieneMichelin) {
          navigate('/pedidosplataforma.html');
        } else {  
          navigate('/pedidos.html');
        }
      } catch (error) {
        console.log(error);
        setErrorMessage('Error de conexión con el servidor');
      }
    }
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="lg">
        <Box p={3} display="flex" flexDirection="column" alignItems="stretch">
          {errorMessage && (
            <Alert severity="error" onClose={() => setErrorMessage("")}>
              <AlertTitle>Error</AlertTitle>
              {errorMessage}
            </Alert>
          )}

          <Typography
            variant="h4"
            gutterBottom
            sx={{
              color: "#cf1316",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {tieneMichelin ? "Carrito de Pedido Michelin" : "Carrito de Pedido"}
          </Typography>

          <Grid container spacing={4}>
            <Grid
              item
              xs={12}
              md={6}
              sx={{ textAlign: "left", marginRight: 8 }}
            >
              <Typography>
                <b>Cliente:</b> {Nombre}
              </Typography>
              <Typography>
                <b>Asesor:</b> {Asesor}
              </Typography>
              <Typography>
                <b>Seguimiento:</b> {Seguimiento}
              </Typography>
              {(PedidoExpress === 1 || PedidoExpress === "1") &&
                permitirPedidoExpress && (
                  <Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<TwoWheelerIcon />}
                          checkedIcon={<TwoWheelerIcon />}
                          checked={pedidoExpressActivo}
                          onChange={(e) =>
                            setPedidoExpressActivo(e.target.checked)
                          }
                        />
                      }
                      label="Pedido Express"
                    />
                  </Typography>
                )}
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ width: "100%", overflowX: "auto" }}>
                <TableContainer component={Paper} sx={{ mb: 3, minWidth: 50 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">MSPN</TableCell>
                        <TableCell align="center">Descripción</TableCell>
                        <TableCell align="center">Cantidad</TableCell>
                        <TableCell align="center">Precio</TableCell>
                        <TableCell align="center">Eliminar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {carrito.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell
                            align="center"
                            sx={{ whiteSpace: "nowrap" }}
                          >
                            {item.MSPN}
                          </TableCell>
                          <TableCell align="center">
                            {item.descripcion}
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              type="number"
                              value={item.cantidad}
                              onChange={(e) => {
                                const valor = parseInt(e.target.value, 10);

                                const esMichelin = codigosApiMichelin.includes(
                                  item.MSPN?.toUpperCase(),
                                );

                                if (!isNaN(valor) && valor > 0) {
                                  if (esMichelin) {
                                    modificarCantidad(item.MSPN, valor);
                                    return;
                                  }

                                  if (valor <= item.existencias) {
                                    modificarCantidad(item.MSPN, valor);
                                  }
                                }
                              }}
                              inputProps={{ min: 1 }}
                              size="small"
                              sx={{ width: 70 }}
                            />
                          </TableCell>
                          <TableCell align="center">{item.precio}</TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => eliminarDelCarrito(item.MSPN)}
                              sx={{ color: "red" }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell colSpan={2} align="center">
                          <strong>Total</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>{totalCantidad}</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>{totalPrecio}</strong>
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>

          {tieneMichelin && (
            <Box
              mt={3}
              p={3}
              component={Paper}
              variant="outlined"
              sx={{
                width: "100%",
                boxSizing: "border-box",
                
                display: "grid",
                gap: 2, 
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
              }}
            >
              <Typography
                variant="h6"
                color="primary"
                sx={{
                  fontWeight: "bold",
                  gridColumn: { xs: "span 1", sm: "span 3" },
                }}
              >
                Datos del Destinatario (Entrega Michelin Directa)
              </Typography>

              <TextField
                required
                label="Nombre Completo"
                name="nombreEntrega"
                fullWidth
                size="small"
                value={datosEntrega.nombreEntrega}
                onChange={handleDatosEntregaChange}
                sx={{ gridColumn: { xs: "span 1", sm: "span 3" } }}
              />

              <TextField
                required
                multiline
                minRows={2}
                maxRows={2}
                label="Dirección de Entrega"
                name="direccion"
                fullWidth
                size="small"
                value={datosEntrega.direccion}
                onChange={handleDatosEntregaChange}
                sx={{ gridColumn: { xs: "span 1", sm: "span 3" } }}
              />

              <TextField
                required
                label="Código Postal"
                name="cp"
                fullWidth
                size="small"
                value={datosEntrega.cp}
                onChange={handleDatosEntregaChange}
                sx={{ gridColumn: "span 1" }}
              />

              <TextField
                required
                label="Teléfono"
                name="telefono"
                fullWidth
                size="small"
                value={datosEntrega.telefono}
                onChange={handleDatosEntregaChange}
                sx={{ gridColumn: "span 1" }}
              />

              <TextField
                required
                label="Correo Electrónico"
                name="correo"
                type="email"
                fullWidth
                size="small"
                value={datosEntrega.correo}
                onChange={handleDatosEntregaChange}
                sx={{ gridColumn: "span 1" }}
              />
            </Box>
          )}

          <Box mt={4} width="100%">
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              gap={2}
              maxWidth={800}
            >
              {pedidoExpressActivo && (
                <Box
                  mt={4}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                >
                  <Typography variant="h6" fontWeight="bold" textAlign="center">
                    Elige la dirección para el Pedido Express
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={() => setOpenDireccionModal(true)}
                    sx={{
                      backgroundColor: "#242c59",
                      "&:hover": { backgroundColor: "#1e2447" },
                    }}
                  >
                    Agregar Dirección
                  </Button>

                  <ModalAgregarDireccion
                    open={openDireccionModal}
                    onClose={() => setOpenDireccionModal(false)}
                    setDirecciones={setDirecciones}
                    IdUsuario={IdUsuario}
                    recargarDirecciones={obtenerDirecciones}
                  />

                  <Box width="100%" maxWidth={600} mb={2}>
                    {direcciones.map((dir) => (
                      <Paper
                        key={dir.Direccion}
                        onClick={() => setDireccionSeleccionada(dir.Direccion)}
                        sx={{
                          p: 2,
                          my: 1,
                          cursor: "pointer",
                          border:
                            direccionSeleccionada === dir.Direccion
                              ? "2px solid #cf1316"
                              : "1px solid #ccc",
                          minWidth: 250,
                          textAlign: "center",
                        }}
                      >
                        {dir.Direccion}
                      </Paper>
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
            <TextField
              label="Comentario"
              placeholder="Escribe algún comentario adicional sobre el pedido..."
              multiline
              rows={3}
              variant="outlined"
              fullWidth
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
            />
          </Box>
          { /* tieneAdvantage && (
            <p>
              Recuerda que en la compra de 4 llantas BFGoodrich Advantage te
              regalamos una playera de México.
            </p>
          ) */}

          {tieneMichelin && (
            <>
              <p>
                Recuerda que este pedido se entregará en tu sucursal por lo cual
                solicitammos que la direccion de tu sucursal este correcta, de lo
                contrario el pedido podría retrasarse o no ser entregado. Estás
                realizando pedido directo a los almacenes de Michelin.
              </p>
              <p>
                Nota: Al ser pedido directo a Michelin, no hay devoluciones ni cambios, por lo que es importante verificar que los datos sean correctos antes de confirmar el pedido.
              </p>
            </>

          )}
          <Box
            mt={4}
            display="flex"
            justifyContent="center"
            flexWrap="wrap"
            gap={2}
            width="100%"
          >
            <Button
              variant="contained"
              color="error"
              onClick={limpiarCarrito}
              fullWidth
              sx={{ maxWidth: 250 }}
            >
              Cancelar Pedido
            </Button>

            <Button
              variant="contained"
              onClick={handleSubmit}
              fullWidth
              sx={{
                backgroundColor: "green",
                "&:hover": { backgroundColor: "#0b7d0b" },
                maxWidth: 250,
              }}
            >
              Confirmar Pedido
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default CarritoPedido;
